module.exports = __webpack_public_path__ + "static/media/close.2d294d63.svg";